import * as React from 'react';

var _path, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgHouse = function SvgHouse(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_110_342",
        width: 80,
        height: 80,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M0 0h80v80H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_110_342)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_110_342)",
        d: "M13.937 65.039h15.42V41.942h16.74V65.04h15.42V29.06l-23.79-18.174-23.79 18.15zm0 2.961q-1.17 0-2.054-.89T11 65.039V29.06q0-.687.272-1.302.273-.614.918-1.022L35.98 8.563q.425-.282.858-.422T37.74 8t.896.14.839.423l23.79 18.174q.645.407.917 1.022.273.615.272 1.302V65.04q0 1.18-.882 2.07-.883.891-2.055.891H43.162V44.903H32.294V68z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_110_342)",
        fillOpacity: 0.16,
        d: "M15.883 71.11q.883.89 2.054.89h18.357V48.903H47.16V72h18.356q1.172 0 2.055-.89.882-.89.882-2.071V33.06q0-.687-.272-1.302-.272-.614-.917-1.022l-23.79-18.174a3.4 3.4 0 0 0-.84-.422A2.8 2.8 0 0 0 41.74 12q-.47 0-.902.14a3.5 3.5 0 0 0-.858.423L16.19 30.737q-.645.407-.918 1.022A3.2 3.2 0 0 0 15 33.061V69.04q0 1.18.883 2.07"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_110_342",
        x1: 11.558,
        x2: 63.71,
        y1: 38,
        y2: 38,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_110_342",
        x1: 15.558,
        x2: 67.71,
        y1: 42,
        y2: 42,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgHouse as ReactComponent };
//# sourceMappingURL=House.svg.es.js.map
